import { render } from "./CreateBidTMS.vue?vue&type=template&id=28512bfa&scoped=true&ts=true"
import script from "./CreateBidTMS.vue?vue&type=script&lang=ts"
export * from "./CreateBidTMS.vue?vue&type=script&lang=ts"

import "./CreateBidTMS.vue?vue&type=style&index=0&id=28512bfa&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28512bfa"]])

export default __exports__